<template>
  <div>
    <slot name="activator" v-bind:openModal="openModal"></slot>
    <div class="modal__overlay" v-show="isShowModalFlag">
      <!-- モーダルウィンドウ -->
      <div v-bind:class="[modalWindowClass]" v-show="isShowModalFlag">
        <div class="modal-title h5">
          <p><slot name="modalTitle"></slot></p>
          <span @click="closeModal">×</span>
        </div>
        <div v-bind:class="[modalWrapperClass]">
          <slot name="modal-content" v-bind:closeModal="closeModal"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<!--Scssパターン-->
<style lang="scss" scoped>

/* オーバーレイ */
.modal__overlay {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(120, 120, 120, 0.8);

  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-title {
  background-color: #a07abe;
  border-top-right-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  color: #ffffff;
  padding: 0.5rem 0.8rem;

  p {
    margin: 0;
    display: inline-block;
  }
  span {
  float: right;
  font-weight: 100;
  cursor: pointer;
  }
}
.modal-btn {
  margin: 0.5rem 0;
}
/* モーダルウィンドウ */
.modal-window {
  z-index: 11;
  width: 50%;
  border-radius: 0.25rem;
  background-color: #fffbf9;
}
.modal-wrapper {
  padding: 1.5rem 2.0rem;
}
.modal-window--wide {
  z-index: 11;
  width: 80%;
  border-radius: 0.25rem;
  background-color: #fffbf9;
}
.modal-window--narrow {
  z-index: 11;
  width: 35%;
  border-radius: 0.25rem;
  background-color: #fffbf9;
}
.modal-wrapper--long {
  padding: 1.5rem 2.0rem;
  height: 80vh;
  overflow-y: scroll;
}
</style>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      isShowModalFlag: false,
      modalWindowClass: "modal-window",
      modalWrapperClass: "modal-wrapper",
    };
  },
  props: {
    onClose: {
      type: Function,
      default: null,
    },
  },
  methods: {
    // resizeModalWidth: function($width=50){
      // console.log($width);
    // },
    openModal: function ({is_wide=false, is_narrow=false, is_long=false, }={})
    {
      if (is_wide == true){
        this.modalWindowClass = "modal-window--wide"
      }

      if (is_narrow == true){
        this.modalWindowClass = "modal-window--narrow"
      }

      if (is_long == true){
        this.modalWrapperClass = "modal-wrapper--long"
      }

      this.isShowModalFlag = true;
    },
    closeModal: function () {
      if (this.onClose) {
        // モーダルを閉じる時の処理を実行
        this.onClose();
      }
      this.isShowModalFlag = false;
    },
  },
});
</script>